const initialState = {
  uploadError: {},
  loading: false,
  crewInspectionData: {},
};

const crewInspection = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'CREW_INSPECTION_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CREW_INSPECTION_CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        crewInspectionData: payload.crewInspectionData,
        uploadError: '',
      };
    case 'CREW_INSPECTION_CREATE_FAILURE':
      return {
        ...state,
        crewInspectionData: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default crewInspection;



// WEBPACK FOOTER //
// ./client/app/reducers/crew_inspection.js